import c from "classnames";
import { PropsWithChildren } from "react";

import { CardHeaderActions } from "./ui/CardHeaderActions/CardHeaderActions";
import { CardHeaderTitle } from "./ui/CardHeaderTitle/CardHeaderTitle";

import classes from "./CardHeader.module.css";

type Props = PropsWithChildren<{
  withBottomPadding?: boolean;
}>;

export const CardHeader = ({ withBottomPadding, ...props }: Props) => {
  return (
    <header
      className={c(
        classes.cardHeader,
        withBottomPadding && classes.withBottomPadding,
      )}
      {...props}
    />
  );
};

CardHeader.Actions = CardHeaderActions;
CardHeader.Title = CardHeaderTitle;
